import { Paper, Skeleton } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import PageTitle from "../../../../components/pageTitle";
import { handleAllUsers, resetAllSummeryData } from "../../../../redux/actoin";
import { API } from "../../../../scripts/api";
import axiosInstance from "../../../../scripts/axiosInspector";
import ProductForm from "../create/form";

const EditCustomer = () => {
  const [data, setData] = useState({});
  const [loadingSubmit, setLoadingSubmit] = useState(false);
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();

  const userLogin = useSelector((state) => state.userLogin);
  const { userInfo } = userLogin;
  const CurrentCompany = useSelector((state) => state.CurrentCompany);
  const { company } = CurrentCompany;
  const { id } = useParams();
  const AllUsers = useSelector((state) => state.AllUsers);

  const navigate = useNavigate();
  const handleSumbit = () => {
    setLoadingSubmit(true);
    axiosInstance
      .put(
        API.info.customerSingle,
        {
          ...data,
          guidStuffRecNo: data?.guidStuffRecNo?.guidRecNo,
          guidStateRecNo: company?.guidRecNo,
        },
        {
          headers: {
            Authorization: `Bearer ${userInfo?.token}`,
            "Cache-Control": "no-cache",
            Pragma: "no-cache",
            Expires: "0",
            "Accept-Language": "fa-IR",
            chHostName: process.env.REACT_APP_CHHOSTNAME,
          },
        }
      )
      .then((res) => {
        if (res?.data?.isSuccess) {
          dispatch(resetAllSummeryData());

          var message = res?.data?.message;
          if (AllUsers.users?.page) {
            axiosInstance
              .get(
                API.info.customerItem +
                  `?guidStateRecNo=${company?.guidRecNo}&guidRecNo=${id}`,
                {
                  headers: {
                    Authorization: `Bearer ${userInfo?.token}`,
                    "Cache-Control": "no-cache",
                    Pragma: "no-cache",
                    Expires: "0",
                    "Accept-Language": "fa-IR",
                    chHostName: process.env.REACT_APP_CHHOSTNAME,
                  },
                }
              )
              .then((res) => {
                toast.success(message);
                var temp = [...AllUsers.users?.customers];
                var index = temp.findIndex(
                  (it) => it.guidRecNo === data?.guidRecNo
                );
                temp[index] = res?.data?.data;
                dispatch(
                  handleAllUsers({
                    ...AllUsers.users,
                    customers: temp,
                  })
                );
                navigate("/sell/customer");
                setLoadingSubmit(false);
              })
              .catch((err) => {
                setLoadingSubmit(false);
              });
          } else {
            navigate("/sell/customer");
            toast.success(res?.data?.message);
          }
        } else {
          toast.error(res?.data?.message);
        }
        setLoadingSubmit(false);
      })
      .catch((err) => {
        toast.error("خطایی رخ داده است مجدد تلاش کنید");
        setLoadingSubmit(false);
      });
  };
  useEffect(() => {
    if (id) {
      setLoading(true);
      axiosInstance
        .get(
          API.info.customerItem +
            `?guidStateRecNo=${company?.guidRecNo}&guidRecNo=${id}`,
          {
            headers: {
              Authorization: `Bearer ${userInfo?.token}`,
              "Cache-Control": "no-cache",
              Pragma: "no-cache",
              Expires: "0",
              "Accept-Language": "fa-IR",
              chHostName: process.env.REACT_APP_CHHOSTNAME,
            },
          }
        )
        .then((res) => {
          setData(res?.data?.data);
          setLoading(false);
        })
        .catch((err) => {
          setLoading(false);
          /*         if (err.response.status === 401 || err.response.status === 403) {
            dispatch(handleLogOut());
          } */
        });
    }
  }, [id]);
  return (
    <>
      {" "}
      <PageTitle
        broadCrumb={[
          {
            title: "فروش",
            path: "/sell",
          },
          {
            title: "خریداران",
            path: "/sell/customer",
          },
        ]}
        title={"ویرایش خریدار"}
      />
      {loading ? (
        <>
          {" "}
          <Paper
            elevation={1}
            className="mx-3 my-5 border py-3 px-3 flex flex-col gap-4"
          >
            <Skeleton variant="rounded" width={"100%"} height={40}></Skeleton>
            <Skeleton variant="rounded" width={"100%"} height={80}></Skeleton>
            <Skeleton variant="rounded" width={"100%"} height={80}></Skeleton>
            <Skeleton variant="rounded" width={"100%"} height={80}></Skeleton>
            <Skeleton variant="rounded" width={"100%"} height={80}></Skeleton>
          </Paper>
        </>
      ) : (
        <>
          {" "}
          <ProductForm
            data={data}
            setData={setData}
            handleSumbit={handleSumbit}
            loadingSubmit={loadingSubmit}
          />
        </>
      )}
    </>
  );
};

export default EditCustomer;
